import './OrganizationCard.less';
import React from 'react';
import { Card, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface OrganizationCreattionCardProps {
  width?: number;
  onAdd: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
}

const OrganizationAddCard: React.FC<OrganizationCreattionCardProps> = ({
  width = 400,
  onAdd,
  disabled = false,
  disabledTooltip,
}) => {
  const cardContent = (
    <Card
      className={`organization-card create ${disabled ? 'disabled' : ''}`}
      style={{
        width,
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      onClick={disabled ? undefined : onAdd}
    >
      <PlusOutlined />
      <div>Add organization</div>
    </Card>
  );

  if (disabled && disabledTooltip) {
    return <Tooltip title={disabledTooltip}>{cardContent}</Tooltip>;
  }

  return cardContent;
};

export default OrganizationAddCard;
